export const BASE_URL = "https://www.tamilmurasu.com.sg";

export const CACHE_EXPIRY_TIME = 300;

// Site Map Constants
export const SIZE_COUNT = 10000;
export const PUB_NAME = "Tamilmurasu";
export const PUB_LANGUAGE = "ta";
export const OLDEST_YEAR = 2015;

/**
 * HTTP Status Codes
 * Standard HTTP status codes used across all API endpoints
 */
export const HTTP_STATUS = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500,
} as const;

export type HttpStatusCode = (typeof HTTP_STATUS)[keyof typeof HTTP_STATUS];

/**
 * HTTP Methods
 */
export enum HttpMethod {
  GET = "get",
  POST = "post",
  PUT = "put",
  DELETE = "delete",
  PATCH = "patch",
}

/**
 * Cache Control Headers
 * CloudFront optimized cache headers with stale-while-revalidate
 * and stale-if-error patterns for improved resilience
 */
export const CACHE_CONTROL = {
  CLOUDFRONT: {
    /** Menu data: 30 days fresh, 5min stale-while-revalidate, 1 day stale-if-error */
    HEADER_MENU:
      "public, max-age=2592000, stale-while-revalidate=300, stale-if-error=86400",

    /** Dynamic feeds (videos, word quiz, section): 5min fresh, 1min SWR, 1 day SIE */
    DYNAMIC:
      "public, max-age=300, stale-while-revalidate=60, stale-if-error=86400",

    /** Most-read / hourly data: 1hr fresh, 30s SWR, 1 day SIE */
    ONE_HOUR: "max-age=3600, stale-while-revalidate=30, stale-if-error=86400",
  },
} as const;

/**
 * Mobile Platform Constants
 * Used for platform validation in both API endpoints and SSR
 */

/** Valid platform values for mobile APIs */
export const VALID_PLATFORMS = ["ios", "android"] as const;
export type ValidPlatform = (typeof VALID_PLATFORMS)[number];

/** Header name for platform identification */
export const PLATFORM_HEADER = "platform";

/**
 * SSR Cache Configuration
 * Cache max-age (in seconds) for SSR page responses
 */
export const SSR_CACHE_MAX_AGE = 180;
